import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css';
import axios from 'axios';
import {
    postConfig,
    post,
    get,
} from './network/request'
import '@/icons'
import '@/assets/css/common.css'
import globalMethod from '@/public_js/globalmethod'

import {format} from "date-fns";
import {parseISO} from "date-fns/fp";
import * as math from 'mathjs'
import qs from 'qs';
import {im} from "mathjs";

import * as echarts from 'echarts'
// @ts-ignore
import md5 from 'js-md5'
import '../src/assets/css/common.css'
// import Cropperjs from 'cropperjs'

// import preventReClick from '@/public_js/preventReClick'















import {
    Tabbar,
    TabbarItem,
    Tab,
    Tabs,
    PullRefresh,
    Loading,
    List,
    NavBar,
    Swipe,
    SwipeItem,
    Calendar,
    Empty,
    Rate,
    Search,
    Overlay,
    Form,
    Field,
    Toast,
    Popup,
    Uploader,
    Picker,
    Area,
    Dialog,
    Lazyload,

} from 'vant';










// import vant from 'vant'
// Vue.use(vant)
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(PullRefresh);
Vue.use(Loading);
Vue.use(List);
Vue.use(NavBar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Swipe);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Calendar);
Vue.use(Empty);
Vue.use(Rate);
Vue.use(Search);
Vue.use(Overlay);
Vue.use(Form);
Vue.use(Field);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(Area);
// Vue.use(Dialog);
Vue.use(Lazyload, {lazyComponent: true,});




Vue.prototype.$dialog = Dialog;




Vue.config.productionTip = false;
Vue.prototype.axios = axios;
Vue.prototype.$postConfig= postConfig;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$format = format;
Vue.prototype.$parseISO = parseISO;
Vue.prototype.$math = math
Vue.prototype.qs = qs;
Vue.prototype.$md5 = md5;
Vue.prototype.$echarts = echarts
// Vue.prototype.Cropper = Cropperjs
Vue.use(globalMethod)



new Vue({
    router,
    store,


    render: h => h(App)
}).$mount('#app')


//wx2fed3ec5a4c96ec6  appId 微信分享用
